import { useLocation } from 'react-router-dom';

import { ROUTES } from '@/config/routes';
import useFundedAccount from '@/hooks/use-funded-account';
import { useAccountStore } from '@/store/use-account-store';
import { CapitalStatus } from '@/types';

export default function FundedAccountBanner() {
  const { pathname } = useLocation();
  const { isFundedOrEval } = useFundedAccount();
  const capitalStatus = useAccountStore((state) =>
    state.getCapitalStatus(state.address),
  );

  if (
    !isFundedOrEval ||
    pathname === ROUTES.PORTFOLIO ||
    pathname === ROUTES.ACCOUNTS ||
    capitalStatus === CapitalStatus.FUNDED ||
    capitalStatus === CapitalStatus.FUNDED_CLAIMED
  )
    return;

  const isGoalPassed = capitalStatus === CapitalStatus.GOAL_PASSED;
  const isBlocked =
    capitalStatus === CapitalStatus.BLOCKED ||
    capitalStatus === CapitalStatus.FUNDED_BLOCKED;
  const isGoalFailed =
    capitalStatus === CapitalStatus.GOAL_FAILED_MAX_DAILY_LOSS ||
    capitalStatus === CapitalStatus.GOAL_FAILED_MAX_DRAWDOWN ||
    capitalStatus === CapitalStatus.FUNDED_FAILED_MAX_DAILY_LOSS ||
    capitalStatus === CapitalStatus.FUNDED_FAILED_MAX_DRAWDOWN;
  const wasFunded =
    capitalStatus === CapitalStatus.FUNDED_FAILED_MAX_DAILY_LOSS ||
    capitalStatus === CapitalStatus.FUNDED_FAILED_MAX_DRAWDOWN;

  if (isBlocked) return;

  if (isGoalPassed) {
    return (
      <div className="relative z-40 flex items-center justify-center gap-2 border-b border-border bg-green px-6 py-2.5 text-black sm:px-8">
        <p className="text-sm tracking-wider sm:text-base">
          <strong className="uppercase">Congratulations!</strong>
          <span className="hidden sm:inline">
            {' '}
            — You&apos;ve successfully passed the evaluation.
          </span>
        </p>
      </div>
    );
  }

  if (isGoalFailed) {
    return (
      <div className="relative z-40 flex items-center justify-center gap-2 border-b border-border bg-red px-6 py-2.5 text-black sm:px-8">
        <p className="text-sm tracking-wider sm:text-base">
          <strong className="uppercase">
            {wasFunded ? 'Funded Account Liquidated' : 'Evaluation Failed'}
          </strong>
        </p>
      </div>
    );
  }

  if (capitalStatus === CapitalStatus.ACTIVE) {
    return (
      <div className="relative z-40 flex items-center justify-center gap-2 border-b border-border bg-yellow px-6 py-2.5 text-black sm:px-8">
        <p className="text-sm tracking-wider sm:text-base">
          <strong className="uppercase">Evaluation Mode</strong>
          <span className="hidden sm:inline">
            {' '}
            — Trading is subject to evaluation rules
          </span>
        </p>
      </div>
    );
  }

  return (
    <div className="relative z-40 flex items-center justify-center gap-2 border-b border-border bg-yellow px-6 py-2.5 text-black sm:px-8">
      <p className="text-sm tracking-wider sm:text-base">
        <strong className="uppercase">Evaluation Mode</strong>
        <span className="hidden sm:inline">
          {' '}
          — An unknown error as occured. Error code:{' '}
          {capitalStatus.toUpperCase()}
        </span>
      </p>
    </div>
  );
}
